import React from "react";
import HeaderFinanace from '../headerfinanace'
export default function Menu(){
    return(
        <HeaderFinanace/>
    )
}